import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import * as React from 'react';
import { GIFS } from '@app/styles';
import { Minute } from '@nu-art/ts-common';
import './QuaiAdvisorPageLoader.scss';
/**
 * Default advisor loader will also update its statuses if the request is slow in order to give better indication
 * to the user of the status of the request
 * @param props
 * @constructor
 */
export const QuaiAdvisorPageLoader = (props) => {
    return _jsxs(LL_V_L, { id: 'quai-advisor-page-loader', onClick: props.onClick, onDoubleClick: props.onDoubleClick, children: [_jsx(GIFS.advisorLogo, {}), _jsx(QuaiAdvisorPageLoader_Text, { text: props.text })] });
};
const messages = [
    'We\'re on it! Please wait a moment...',
    'We\'re still processing your request. Thank you for your patience!',
];
const QuaiAdvisorPageLoader_Text = (props) => {
    const [text, setText] = React.useState(props.text);
    const [timeOut, setTimeOut] = React.useState(false);
    React.useEffect(() => {
        const timers = [];
        //Set message switching with a stagger of 1 minute.
        messages.forEach((message, index) => {
            timers.push(setTimeout(() => {
                setText(message);
            }, (index + 1) * Minute));
        });
        //Set timeout true 1 minute after the last message is rendered
        timers.push(setTimeout(() => {
            setTimeOut(true);
        }, (messages.length + 1) * Minute));
        // Cleanup timers on unmount
        return () => timers.forEach(clearTimeout);
    }, []);
    if (timeOut)
        return _jsx("div", { className: 'quai-advisor-page-loader__text', children: "We're having difficulties. Please restart the app or contact support." });
    return _jsx("div", { className: 'quai-advisor-page-loader__text', children: text });
};
//# sourceMappingURL=QuaiAdvisorPageLoader.js.map